export default "__VITE_ASSET__BeLwQpMa__"